import type { BrandedQuoteModule } from 'types/capi/article';

import { BrandedQuoteCore } from '~/components/Content/BrandedQuote';
import type { ColumnPosition } from '~/modules/ste/ModuleRow';
import { useModuleRowContext } from '~/modules/ste/ModuleRow';

type Props = {
  columnPosition: ColumnPosition;
  quote: BrandedQuoteModule;
};

export default function EmbeddedBrandedQuote({ columnPosition, quote }: Props) {
  const moduleRow = useModuleRowContext();

  const xPadding =
    columnPosition === 'first'
      ? 'md:pl-8 lg:pl-4'
      : columnPosition === 'last'
        ? 'md:pr-8 lg:pr-4'
        : '';

  return (
    <blockquote
      className={`flex w-full flex-col gap-2 p-4 md:py-6 ${xPadding} ${
        !moduleRow?.narrow ? 'md:mx-auto md:max-w-[360px]' : ''
      }`}
    >
      <BrandedQuoteCore quote={quote} />
    </blockquote>
  );
}
